/* https://rgb.to/hex/e41a1c */
export const CANDLE_RED_COLOR = "hsl(359, 80%, 50%)";
export const CANDLE_GREEN_COLOR = "hsl(118, 41%, 49%)";
export const CANDLE_GRAY_COLOR = "hsl(0, 0%, 60%)";

export const SUPPORT_COLOR = "hsl(122, 38%, 56%)";
export const RESISTANCE_COLOR = "hsl(1, 83%, 62%)";

export const AREA_COLOR_MAP = {
  support: SUPPORT_COLOR,
  resistance: RESISTANCE_COLOR,
  gray: "hsl(0, 0%, 60%)",
};

export const COLOR_BG1 = "#0b0e11";
export const COLOR_BG2 = "#181a20";
export const COLOR_BG3 = "#5e6673";

export const COLOR_TEXT1 = "#eaecef";
export const COLOR_TEXT2 = "#848e9c";
